import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Stack,
  IconButton
} from '@mui/material';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import userApi from '../../api/userApi';
import { useNavigate } from 'react-router-dom';
import { ArrowUpward, ArrowDownward, Visibility, Download } from '@mui/icons-material';
import ConfirmDeleteModal from '../../components/ConfirmDeleteModal';

import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { formatDate } from '../../utils/dateFormatter';

export default function UtentiListPage() {
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const navigate = useNavigate();
  const pageSize = 10;

  useEffect(() => {
    fetchUsers(0);
  }, []);

  const fetchUsers = (page) => {
    userApi
      .list({ page, size: pageSize })
      .then(r => {
        setUsers(r.data.content || []);
        setTotalPages(r.data.totalPages || 0);
        setPage(r.data.number || 0);
        console.log("utenti",r.data.content);
      })
      .catch(err => console.error("Errore caricamento utenti:", err));
  };

  const openDeleteDialog = (id) => {
    setSelectedId(id);
    setOpenDeleteModal(true);
  };

  const closeDeleteDialog = () => {
    setSelectedId(null);
    setOpenDeleteModal(false);
  };

  const confirmDelete = async () => {
    try {
      await userApi.delete(selectedId);
      fetchUsers(page);
    } catch (err) {
      console.error("Errore eliminazione utente:", err);
    }
    closeDeleteDialog();
  };

const exportToCSV = async () => {
  try {
    // Prima recuperiamo il numero totale di utenti
    const initialRes = await userApi.list({ page: 0, size: 1 });
    const totalRecords = initialRes.data.totalElements;
    if (!totalRecords) return;

    // Poi prendiamo tutti gli utenti
    const res = await userApi.list({ page: 0, size: totalRecords });
    const allUsers = res.data.content;
    if (!allUsers || !allUsers.length) return;

    // Prepara CSV
    const headers = Object.keys(allUsers[0]);
    const rows = allUsers.map(u => headers.map(h => u[h] ?? ''));

    const csvContent = "data:text/csv;charset=utf-8,"
      + [headers.join(";"), ...rows.map(r => r.join(";"))].join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "utenti_full.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    console.error('Errore esportazione CSV:', err);
  }
};


  return (
    <Container>
      <Typography variant="h4" sx={{ mb: 2 }}>Utenti</Typography>
    <Stack direction="row" spacing={1} sx={{ mb: 2, alignItems: 'center' }}>
      <Button
        variant="contained"
        onClick={() => navigate('/users/create')}
      >
        Nuovo Utente
      </Button>

      <Button
        variant="outlined"
        startIcon={<Download />}
        onClick={exportToCSV}
      >
        Esporta CSV
      </Button>
    </Stack>
          {/* Pagination */}
          <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
            {Array.from({ length: totalPages }, (_, i) => (
              <Button
                key={i}
                variant={i === page ? "contained" : "outlined"}
                onClick={() => fetchUsers(i)}
              >
                {i + 1}
              </Button>
            ))}
          </Stack>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Username</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Profilo</TableCell>
            <TableCell>Denominazione</TableCell>
            <TableCell>Contratto</TableCell>
            <TableCell>Scadenza Contratto</TableCell>
            <TableCell align="left">Azioni</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {users.map(u => (
            <TableRow key={u.id}>
              <TableCell>{u.username}</TableCell>
              <TableCell>{u.email}</TableCell>
              <TableCell>{u.profile}</TableCell>
              <TableCell>
              {u.studio != null?u.studio.ragionesociale:""}
                  </TableCell>
              {/* CONTRATTO */}
              <TableCell>
                <Stack direction="row" spacing={0.5}>
                  {/* CREA CONTRATTO */}
                  {u.contrattoId == null && (
                    <IconButton
                      color="primary" size="small"
                      title="Crea contratto"
                      onClick={() =>
                        navigate(`/contratti/create?utenteId=${u.id}&redirect=/users`)
                      }
                    >
                      <AddCircleOutlineIcon />
                    </IconButton>
                  )}

                  {/* DETTAGLIO / RINNOVO */}
                  {u.contrattoId != null && (
                    <>
                      <IconButton
                        color="primary" size="small"
                        title="Dettaglio contratto"
                        onClick={() =>
                          navigate(`/contratti/${u.contrattoId}`)
                        }
                      >
                        <VisibilityIcon />
                      </IconButton>
                  <IconButton
                    size="small" color="secondary"
                    title="Modifica contratto"
                    onClick={() => navigate(`/contratti/${u.contrattoId}/edit`)}
                  >
                    <EditIcon />
                  </IconButton>
                      {u.contrattoScaduto && (
                        <IconButton
                          size="small"
                          color="warning"
                          title="Rinnova contratto"
                          onClick={() =>
                            navigate(`/contratti/create?utenteId=${u.id}&renew=true&redirect=/users`)
                          }
                        >
                          <AutorenewIcon />
                        </IconButton>
                      )}
                    </>
                  )}
                </Stack>
              </TableCell>
              <TableCell>
                {u.contratto ?  formatDate(u.contratto.dataFine): '—'}
           </TableCell>
              {/* AZIONI UTENTE */}
              <TableCell align="right">
                <Stack direction="row" spacing={0.5}>
                  {/* CREA STUDIO se STUDIO senza studio */}
                  {u.profile === 'STUDIO' && !u.studio && (
                    <IconButton
                      size="small"
                      color="primary"
                      title="Crea Studio"
                      onClick={() => navigate(`/studi/create?userId=${u.id}`)}
                    >
                      <AddCircleOutlineIcon />
                    </IconButton>
                  )}

                  {/* CREA CONTRIBUENTE se CONTRIBUENTE senza contribuente */}
                  {u.profile === 'CONTRIBUENTE' && !u.contribuenteId && (
                    <IconButton
                      size="small"
                      color="primary"
                      title="Crea Contribuente"
                      onClick={() => navigate(`/contribuenti/create?userId=${u.id}`)}
                    >
                      <AddCircleOutlineIcon />
                    </IconButton>
                  )}

                  {/* ASSOCIA */}
                  {(u.profile === 'CONTRIBUENTE' && !u.contribuenteId ) && (
                    <IconButton
                      size="small"
                      color="secondary"
                      title={'Associa Contribuente'}
                      onClick={() => navigate(`/users/${u.id}/edit`)}
                    >
                      <PersonAddIcon />
                    </IconButton>
                  )}
                   {(u.profile === 'STUDIO') && !u.studio && (
                      <IconButton
                        size="small"
                        color="secondary"
                        title={'Associa Studio'}
                        onClick={() => navigate(`/users/${u.id}/edit`)}
                      >
                        <AccountBalanceIcon />
                      </IconButton>
                    )}

                  <IconButton
                    size="small" color="secondary"
                    title="Modifica utente"
                    onClick={() => navigate(`/users/${u.id}/edit`)}
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton size="small" color="primary"
                    title="Visualizza utente" onClick={() => navigate(`/users/${u.id}`)}>
                    <VisibilityIcon />
                  </IconButton>

                  <IconButton size="small" color="error" onClick={() => openDeleteDialog(u.id)}>
                    <DeleteIcon />
                    </IconButton>
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* Pagination */}
      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        {Array.from({ length: totalPages }, (_, i) => (
          <Button
            key={i}
            variant={i === page ? "contained" : "outlined"}
            onClick={() => fetchUsers(i)}
          >
            {i + 1}
          </Button>
        ))}
      </Stack>

      {/* Modale eliminazione */}
      <ConfirmDeleteModal
        open={openDeleteModal}
        onCancel={closeDeleteDialog}
        onConfirm={confirmDelete}
        message="Sei sicuro di voler eliminare questo utente?"
      />
    </Container>
  );
}